import { render, staticRenderFns } from "./selectMusic.vue?vue&type=template&id=b1be5da6"
import script from "./selectMusic.vue?vue&type=script&lang=js"
export * from "./selectMusic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1be5da6')) {
      api.createRecord('b1be5da6', component.options)
    } else {
      api.reload('b1be5da6', component.options)
    }
    module.hot.accept("./selectMusic.vue?vue&type=template&id=b1be5da6", function () {
      api.rerender('b1be5da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/formOverlay/selectMusic.vue"
export default component.exports